<div class="wizzard-collapse">
    <div class="wizzard-collapse__inner">
        <ng-container *ngFor="let menuFlowPage of menuFlowPages;trackBy: trackBy; let i = index;">

            <shared-wizzard-collapse-page [menuFlowPage]="menuFlowPage" [index]="i"></shared-wizzard-collapse-page>


        </ng-container>
    </div>
</div>
